<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div id="outer" class="well container-fluid">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12"></div>
    </div>
    <div class="col-md-12">
        <div class="col-xs-12">
            @if (selectedMetadata?.Template?.IsOcrFailed && !selectedMetadata?.Template?.IsAi) {
                <div id="templateAlertMessage" class="alert alert-warning">
                    Warning: This scan could not be detected as a document type. You might need to adjust the template
                    for this document, or create a new one.
                    <div class="pull-right">
                        <a
                            id="templateLink"
                            target="_blank"
                            [href]="
                                '/Configure/ZonalTemplateFailedCreateScanPage?scanPageId=' +
                                $safeNavigationMigration(selectedPage?.Page?.ScanPageId)
                            "
                            class="alert-link"
                            style="margin-top: -6px"
                            >Create</a
                        >
                    </div>
                    <div class="clearfix"></div>
                </div>
            }
            <div class="row row-eq-height">
                <div class="col-xs-2">
                    <span class="well-title">Selected Page</span>
                    <cdk-virtual-scroll-viewport
                        id="sideScroll"
                        class="pfScanInbox pfScanLeftbox pfScanBoxMargin"
                        [itemSize]="185"
                        [minBufferPx]="400"
                        [maxBufferPx]="800">
                        <a
                            *cdkVirtualFor="let pg of pages; trackBy: trackByPageId"
                            [id]="'doc_' + pg.Page.ScanPageId"
                            href="#"
                            (click)="selectPage(pg, $event)"
                            [class.docItemSelected]="pg.Page?.ScanPageId === this.selectedPage?.Page?.ScanPageId"
                            ><div [class]="'doc' + pg.LastDigit" class="doc1">
                                <p>Document {{ pg.Page.DocumentNumber }}</p>
                                <img [appScanThumb]="pg.Page.ScanPageId" width="60" /><br /><br /><span
                                    class="pagetitle"
                                    >Page {{ pg.Page.PageNumber }}</span
                                >
                            </div></a
                        >
                    </cdk-virtual-scroll-viewport>
                </div>
                <div class="col-xs-6">
                    <span id="currentText" class="well-title"
                        >Document {{ selectedPage?.Page?.DocumentNumber }}, Page
                        {{ selectedPage?.Page?.PageNumber }}</span
                    >
                    @if (selectedPage) {
                        <div role="form" class="form-horizontal pfScanBoxMargin">
                            <div class="form-group">
                                <div class="col-xs-offset-2 col-xs-6">
                                    Change associated page, document, or document type
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-xs-2 control-label">Document Type</label>
                                <div class="col-xs-6">
                                    <nz-select
                                        name="scanDocType"
                                        nzShowSearch
                                        nzSelectOnTab
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [(ngModel)]="selectedPage.DocumentTypeId"
                                        nzPlaceHolder="Click here to add keywords">
                                        @for (opt of docTypes; track opt) {
                                            <nz-option [nzLabel]="opt.Name!" [nzValue]="opt.Id"> </nz-option>
                                        }
                                    </nz-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-xs-2 control-label">Document</label>
                                <div class="col-xs-6">
                                    <input
                                        name="scanDocNumber"
                                        id="documentNumber"
                                        nz-input
                                        [(ngModel)]="selectedPage.DocNumber"
                                        type="text" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-xs-2 control-label">Page</label>
                                <div class="col-xs-6">
                                    <input
                                        name="scanPageNumber"
                                        id="pageNumber"
                                        nz-input
                                        [(ngModel)]="selectedPage.PageNumber"
                                        type="text" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-xs-2 control-label">Rotate</label>
                                <div class="col-xs-6">
                                    <nz-space-compact>
                                        <button
                                            nz-button
                                            [nzLoading]="rotating"
                                            nzType="default"
                                            (click)="rotatePage(-90)">
                                            <span
                                                nz-icon
                                                style="font-size: 18px"
                                                nzType="undo"
                                                nzTheme="outline"></span>
                                        </button>
                                        <button
                                            nz-button
                                            [nzLoading]="rotating"
                                            nzType="default"
                                            (click)="rotatePage(90)">
                                            <span
                                                nz-icon
                                                style="font-size: 18px"
                                                nzType="redo"
                                                nzTheme="outline"></span>
                                        </button>
                                    </nz-space-compact>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-xs-2 control-label">Zoom</label>
                                <div class="col-xs-6">
                                    <nz-space-compact style="align-items: center">
                                        <button nz-button nzType="default" nzSize="large" (click)="zoomIn()">
                                            <span
                                                nz-icon
                                                style="font-size: 18px"
                                                nzType="zoom-in"
                                                nzTheme="outline"></span>
                                        </button>
                                        <button nz-button nzType="default" nzSize="large" (click)="zoomOut()">
                                            <span
                                                nz-icon
                                                style="font-size: 18px"
                                                nzType="zoom-out"
                                                nzTheme="outline"></span>
                                        </button>
                                        <a
                                            id="pageLink"
                                            target="_blank"
                                            style="margin-left: 10px"
                                            [href]="currentPageUrl"
                                            >View Full Screen</a
                                        ></nz-space-compact
                                    >
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-xs-offset-2 col-xs-6">
                                    <button
                                        nz-button
                                        nz-popconfirm
                                        nzOkText="Delete"
                                        [nzLoading]="deleting"
                                        nzOkDanger
                                        nzPopconfirmTitle="Are you sure you want to delete this page?"
                                        nzPopconfirmPlacement="top"
                                        (nzOnConfirm)="deletePage()"
                                        [nzDanger]="true">
                                        Delete Page
                                    </button>
                                    <button nz-button [nzLoading]="saving" (click)="savePage()">Save Changes</button>
                                </div>
                            </div>
                        </div>
                    }
                    <br />
                    @if (selectedPage) {
                        <div
                            id="currentPageContainer"
                            [class.magnifier-active]="zooming"
                            [ngStyle]="{'background-image': currentPageBg}"
                            (mousemove)="onMagnifierMove($event)"
                            (mouseleave)="onMagnifierLeave()"
                            style="background-size: contain; position: relative">
                            <img id="currentPage" style="width: 100%; visibility: hidden" [src]="currentPageUrl" />
                            @if (activeRegion) {
                                <div
                                    class="canvas-box canvas-box-green zonal-scan-region"
                                    [style.position]="'absolute'"
                                    [style.left.%]="activeRegion.RegionX! * 100"
                                    [style.top.%]="activeRegion.RegionY! * 100"
                                    [style.width.%]="activeRegion.RegionWidth! * 100"
                                    [style.height.%]="activeRegion.RegionHeight! * 100"
                                    [style.border]="'1px dotted black'"
                                    [style.zIndex]="100"
                                    [style.pointerEvents]="'none'"></div>
                            }
                            @if (zooming && !lensVisible) {
                                <div class="magnifier-hint">
                                    Move your cursor over the page to magnify it. Press the minus button to turn it off.
                                </div>
                            }
                            @if (zooming && lensVisible) {
                                <div
                                    class="magnifier-lens"
                                    [style.left.px]="lensX"
                                    [style.top.px]="lensY"
                                    [style.width.px]="lensSize"
                                    [style.height.px]="lensSize"
                                    [style.background-image]="currentPageBg"
                                    [style.background-size]="magnifiedWidth + 'px ' + magnifiedHeight + 'px'"
                                    [style.background-position]="magnifiedPosX + 'px ' + magnifiedPosY + 'px'"></div>
                            }
                        </div>
                    }
                </div>
                <div class="col-xs-4">
                    <span class="well-title">Create Document Data</span>
                    <form id="metaForm" autocomplete="on" name="metaForm" class="pfScanBoxMargin form-horizontal">
                        <table
                            cellspacing="0"
                            cellpadding="3"
                            width="100%"
                            style="border-collapse: separate; border-spacing: 0.3em">
                            <tbody>
                                <tr></tr>
                                <tr>
                                    <td></td>
                                </tr>
                            </tbody>
                            <tbody id="contentRows">
                                @if (aiEnabled && selectedMetadata?.Template?.IsAi) {
                                    <tr>
                                        <td colspan="2">
                                            <button
                                                nz-button
                                                nzBlock
                                                [nzLoading]="reprocessing"
                                                nzType="default"
                                                (click)="reasonModal = true">
                                                Resubmit Document with Hints
                                            </button>
                                        </td>
                                    </tr>
                                }
                                @if (!selectedMetadata?.Template?.IsAi && (scan?.ScanSetupType ?? 0) === 4) {
                                    <tr>
                                        <td style="vertical-align: top">
                                            <label class="control-label">Zonal Template</label>
                                        </td>
                                        <td>
                                            <span>{{ selectedMetadata?.Template?.Name }}</span>
                                            <div style="margin-top: 2px; margin-bottom: 2px"></div>
                                            @if (selectedMetadata?.Template?.Id) {
                                                <a
                                                    nz-button
                                                    nzType="primary"
                                                    target="_blank"
                                                    [href]="
                                                        '/Configure/ZonalTemplateEdit?templateId=' +
                                                        $safeNavigationMigration(selectedMetadata?.Template?.Id)
                                                    ">
                                                    Edit
                                                </a>
                                            }
                                            <button
                                                nz-button
                                                nzType="primary"
                                                style="margin-left: 5px"
                                                (click)="reprocessDocument()">
                                                Reprocess
                                            </button>
                                        </td>
                                    </tr>
                                }
                                @for (meta of selectedMetadata?.Fields; track meta) {
                                    <tr>
                                        <td>
                                            <label class="control-label">
                                                @if (meta.Required) {
                                                    <span style="color: red">*</span>
                                                }
                                                {{ meta.Name }}</label
                                            >
                                        </td>
                                        @if (meta.TypeId === 1 || meta.TypeId === 2) {
                                            <td>
                                                <input
                                                    nz-input
                                                    (focus)="onFieldFocus(meta)"
                                                    (blur)="onFieldBlur()"
                                                    [style.backgroundColor]="
                                                        meta.Confidence
                                                            ? getConfidenceColor(meta.Confidence)
                                                            : undefined
                                                    "
                                                    [nz-tooltip]="
                                                        meta.Confidence
                                                            ? getConfidenceTooltip(meta.Confidence)
                                                            : undefined
                                                    "
                                                    [name]="'meta_' + meta.MetadataId"
                                                    [id]="'meta_' + meta.MetadataId"
                                                    type="text"
                                                    [(ngModel)]="meta.Value" />
                                            </td>
                                        }
                                        @if (meta.TypeId === 3) {
                                            <td>
                                                <nz-date-picker
                                                    style="width: 100%"
                                                    [style.backgroundColor]="
                                                        meta.Confidence
                                                            ? getConfidenceColor(meta.Confidence)
                                                            : undefined
                                                    "
                                                    [nz-tooltip]="
                                                        meta.Confidence
                                                            ? getConfidenceTooltip(meta.Confidence)
                                                            : undefined
                                                    "
                                                    (nzOnOpenChange)="$event ? onFieldFocus(meta) : onFieldBlur()"
                                                    [name]="'meta_' + meta.MetadataId"
                                                    [id]="'meta_' + meta.MetadataId"
                                                    type="text"
                                                    [nzPlaceHolder]="' '"
                                                    [nzFormat]="meta.DateFormat!"
                                                    [(ngModel)]="meta.Value">
                                                </nz-date-picker>
                                            </td>
                                        }
                                    </tr>
                                }
                                <tr>
                                    <td></td>
                                    <td>
                                        <button
                                            nz-button
                                            nzBlock
                                            [nzLoading]="savingMetadata"
                                            nzType="default"
                                            (click)="saveMetadata()">
                                            Save Metadata
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="pfScanBoxMargin"></div>
                        <button nz-button nzBlock [nzLoading]="processing" nzType="default" (click)="finalize()">
                            Process All Documents
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<nz-modal [nzTitle]="'Reprocess AI Scan'" [(nzVisible)]="reasonModal">
    <div *nzModalContent>
        <p nz-typography nzType="secondary">
            Enter a message describing what is wrong with the metadata or document type. This will be utilized to refine
            reprocessing results.
        </p>
        <form nz-form nzLayout="vertical">
            <nz-form-item>
                <nz-form-label [nzRequired]="true"> Reprocess Reason </nz-form-label>
                <nz-form-control>
                    <nz-textarea-count [nzMaxCharacterCount]="500">
                        <textarea
                            name="reasonDetails"
                            nz-input
                            maxlength="500"
                            [(ngModel)]="reasonText"
                            [placeholder]="'Please enter reprocess reason...'"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="6"></textarea>
                    </nz-textarea-count>
                </nz-form-control>
            </nz-form-item>
        </form>
        <ng-template #msgTmpl>
            <i nz-icon nzType="bulb" nzTheme="outline"></i>&nbsp;<b>Tip</b>&nbsp;Consider updating business rules in
            your AI Prompt if you require frequent reprocesses to improve output.
        </ng-template>
        <nz-alert [nzShowIcon]="false" nzType="info" [nzMessage]="msgTmpl" style="margin-top: 10px"></nz-alert>
    </div>
    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="reasonText = ''; reasonModal = false">Cancel</button>
        <button
            nz-button
            nzType="primary"
            [nzLoading]="reprocessing"
            [disabled]="!reasonText"
            (click)="reprocessDocument(reasonText)">
            Reprocess
        </button>
    </div>
</nz-modal>
